/**
 * LinkContent - 链接内容渲染组件
 */

import React from 'react';
import { getProxyUrl } from '../../utils/urlProxy';

export default function LinkContent({ data }) {
  if (!data || !data.links || data.links.length === 0) return null;

  const enabledLinks = data.links.filter(l => l.enabled !== false);
  if (enabledLinks.length === 0) return null;

  const layout = data.layout || 'list'; // list | card-grid | horizontal
  const cs = data.cardStyle || {};
  const iconSize = data.iconSize || 24;
  const cardStyle = {
    background: cs.bgColor || (layout !== 'list' ? '#f8f9fa' : 'transparent'),
    borderRadius: (cs.radius ?? (layout !== 'list' ? 8 : 0)) + 'px',
    border: cs.borderWidth ? `${cs.borderWidth}px solid ${cs.borderColor || '#e8eaed'}` : (layout !== 'list' ? '1px solid #e8eaed' : 'none'),
    boxShadow: cs.shadow ? '0 2px 8px rgba(0,0,0,0.08)' : 'none',
    color: cs.textColor || '#202124',
    textDecoration: 'none',
    padding: (cs.padding ?? (layout !== 'list' ? 12 : 8)) + 'px'
  };

  if (layout === 'card-grid') {
    return (
      <div className="label-content-links">
        <div className="links-grid">
          {enabledLinks.map((link, idx) => (
            <a key={idx} href={link.url} className="related-link-item" target="_blank" rel="noreferrer" style={cardStyle}>
              {link.icon && (
                typeof link.icon === 'string' && (
                  link.icon.startsWith('http') || link.icon.startsWith('data:') || link.icon.startsWith('blob:') || link.icon.startsWith('/')
                ) ? (
                  <img
                    src={getProxyUrl(link.icon)}
                    alt={link.name || '图标'}
                    className="link-icon-img"
                    style={{ width: iconSize, height: iconSize }}
                    loading="lazy"
                    onError={(e) => { e.target.style.display = 'none'; }}
                  />
                ) : (
                  <span className="link-icon" style={{ fontSize: iconSize * 0.8 }}>{link.icon}</span>
                )
              )}
              <span className="link-name" style={{ color: cardStyle.color }}>{link.name}</span>
            </a>
          ))}
        </div>
      </div>
    );
  }

  if (layout === 'horizontal') {
    return (
      <div className="label-content-links">
        {enabledLinks.map((link, idx) => (
          <a key={idx} href={link.url} className="link-item" target="_blank" rel="noreferrer" style={cardStyle}>
            {link.icon && (
              typeof link.icon === 'string' && (
                link.icon.startsWith('http') || link.icon.startsWith('data:') || link.icon.startsWith('blob:') || link.icon.startsWith('/')
                ) ? (
                  <img
                    src={getProxyUrl(link.icon)}
                    alt={link.name || '图标'}
                    className="link-icon-img"
                    style={{ width: iconSize, height: iconSize }}
                    loading="lazy"
                    onError={(e) => { e.target.style.display = 'none'; }}
                  />
                ) : (
                  <span className="link-icon" style={{ fontSize: iconSize * 0.8 }}>{link.icon}</span>
                )
              )}
              <span className="link-name" style={{ color: cardStyle.color }}>{link.name}</span>
            </a>
          ))}
      </div>
    );
  }

  // 默认 list
  return (
    <div className="label-content-links">
      {enabledLinks.map((link, idx) => (
        <a key={idx} href={link.url} className="link-item" target="_blank" rel="noopener noreferrer" style={cardStyle}>
          {link.icon && (
            typeof link.icon === 'string' && (
              link.icon.startsWith('http') || link.icon.startsWith('data:') || link.icon.startsWith('blob:') || link.icon.startsWith('/')
            ) ? (
              <img
                src={getProxyUrl(link.icon)}
                alt={link.name || '图标'}
                className="link-icon-img"
                style={{ width: iconSize, height: iconSize }}
                loading="lazy"
                onError={(e) => { e.target.style.display = 'none'; }}
              />
            ) : (
              <span className="link-icon" style={{ fontSize: iconSize * 0.8 }}>{link.icon}</span>
            )
          )}
          <span className="link-name" style={{ color: cardStyle.color }}>{link.name}</span>
        </a>
      ))}
    </div>
  );
}
